import { useState, useEffect } from 'react';
import { Wifi, WifiOff, RefreshCw } from 'lucide-react';
import { syncManager } from '@/lib/syncManager';

export default function ConnectionStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [queueLength, setQueueLength] = useState(syncManager.getQueue().length);

  useEffect(() => {
    const handleStatus = () => {
      setIsOnline(navigator.onLine);
      setQueueLength(syncManager.getQueue().length);
      if (navigator.onLine) syncManager.sync();
    };

    window.addEventListener('online', handleStatus);
    window.addEventListener('offline', handleStatus);

    const interval = setInterval(() => {
      setQueueLength(syncManager.getQueue().length);
    }, 5000);

    return () => {
      window.removeEventListener('online', handleStatus);
      window.removeEventListener('offline', handleStatus);
      clearInterval(interval);
    };
  }, []);

  const syncing = isOnline && queueLength > 0;

  return (
    <div
      title={!isOnline ? 'Sin conexión — modo offline activo' : syncing ? `Sincronizando ${queueLength} elemento(s)` : 'Conectado'}
      className={`fixed top-16 right-4 z-[100] flex items-center gap-2 px-3 py-1.5 rounded-full shadow-lg border text-[10px] font-black uppercase tracking-widest transition-colors ${
        !isOnline ? 'bg-critical text-white border-critical' :
        syncing ? 'bg-warn text-white border-warn' :
        'bg-success/90 text-white border-success'
      }`}
    >
      {!isOnline ? (
        <>
          <WifiOff size={14} />
          <span>Offline</span>
        </>
      ) : syncing ? (
        <>
          <RefreshCw size={14} className="animate-spin" />
          <span>Sincronizando</span>
          <span className="bg-white/20 px-1.5 rounded">{queueLength}</span>
        </>
      ) : (
        <>
          <Wifi size={14} />
          <span className="hidden sm:inline">En línea</span>
        </>
      )}
    </div>
  );
}
